<template>
  <v-container fluid>
    <div class="mb-4">
      <h2>Orders</h2>
    </div>
    <pre>{{ orders }}</pre>
  </v-container>
</template>

<script>
import OrderApi from "@/api/order";

export default {
  components: {},
  data() {
    return {
      orders: [],
    };
  },
  async created() {
    OrderApi.getUserOrders().then((result) => (this.orders = result.data));
  },
};
</script>
